import { ListItem } from '@mui/material';

import styled from 'styled-components';

import { Constants } from '@arrived/common';

export const DetailsListItem = styled(ListItem)`
  & {
    gap: ${({ theme }) => theme.spacing(2)};
  }

  &.MuiListItem-padding {
    padding: ${({ theme }) => theme.spacing(2, 0)};
  }

  & > *:last-child {
    margin-left: auto;
  }

  &:not(:first-of-type):not(:last-of-type) {
    border-top: 1px solid ${({ theme }) => theme.palette.neutrals.platinum};
  }

  &:last-of-type {
    border-top: 1px solid ${({ theme }) => theme.palette.darkened.steel};
  }
`;
